module.exports = __webpack_public_path__ + "img/组 12945.ca476e15.png";